class SystemMatcher {
  constructor({ inCloudCore, isVirtual, category }) {
    this.inCloudCore = inCloudCore
    this.isVirtual = isVirtual
    this.category = category
    this.value = null
  }

  canSetValue = () => [true, null].includes(this.value)

  cloudCore = () => {
    if (this.canSetValue()) {
      this.value = this.inCloudCore
    }

    return this
  }

  notCloudCore = () => {
    if (this.canSetValue()) {
      this.value = !this.inCloudCore
    }

    return this
  }

  virtual = () => {
    if (this.canSetValue()) {
      this.value = this.isVirtual
    }

    return this
  }

  physical = () => {
    if (this.canSetValue()) {
      this.value = !this.isVirtual
    }

    return this
  }

  workstation = () => {
    if (this.canSetValue()) {
      this.value = ['Laptop', 'Desktop'].includes(this.category)
    }

    return this
  }

  server = () => {
    if (this.canSetValue()) {
      this.value = (this.category === 'Server')
    }

    return this
  }
}

export default SystemMatcher
